import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultInterceptorChainClass;
function DefaultInterceptorChain() {
  if (DefaultInterceptorChainClass === VOID) {
    class $ {
      constructor(interceptors, index) {
        this.f65_1 = interceptors;
        this.g65_1 = index;
      }
      h65(request) {
        // Inline function 'kotlin.check' call
        if (!(this.g65_1 < this.f65_1.v2())) {
          throw IllegalStateException().o('Check failed.');
        }
        return this.f65_1.w2(this.g65_1).i65(request, new (DefaultInterceptorChain())(this.f65_1, this.g65_1 + 1 | 0));
      }
    }
    initMetadataForClass($, 'DefaultInterceptorChain');
    DefaultInterceptorChainClass = $;
  }
  return DefaultInterceptorChainClass;
}
//region block: exports
export {
  DefaultInterceptorChain as DefaultInterceptorChain10weji0clzo5q,
};
//endregion

//# sourceMappingURL=ApolloInterceptor.mjs.map
